import React from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SocialProofBar from './components/SocialProofBar';
import InstitucionesSection from './components/InstitucionesSection';
import PricingSection from './components/PricingSection';
import OnFieldRoles from './components/OnFieldRoles';
import HighlightReel from './components/HighlightReel';
import Footer from './components/Footer';
import DownloadModal from './components/DownloadModal';
import ComingSoonModal from './components/ComingSoonModal';
import { useState } from 'react';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isComingSoonOpen, setIsComingSoonOpen] = useState(false);
  const [activeOnFieldRole, setActiveOnFieldRole] = useState('jugador');

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openComingSoon = () => setIsComingSoonOpen(true);
  const closeComingSoon = () => setIsComingSoonOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onDownloadClick={openModal} onComingSoonClick={openComingSoon} />
      <HeroSection onDownloadClick={openModal} />
      <SocialProofBar />
      <OnFieldRoles activeRole={activeOnFieldRole} onRoleChange={setActiveOnFieldRole} onDownloadClick={openModal} />
      <InstitucionesSection />
      <PricingSection onTrainerStartClick={openModal} />
      <HighlightReel onDownloadClick={openModal} />
      <Footer onDownloadClick={openModal} onNavigateToRole={setActiveOnFieldRole} onComingSoonClick={openComingSoon} />
      
      <DownloadModal isOpen={isModalOpen} onClose={closeModal} />
      <ComingSoonModal isOpen={isComingSoonOpen} onClose={closeComingSoon} />
    </div>
  );
}

export default App;
